module.exports = "/_next/static/files/713089d85ba9e05c93135d01c32ad694.png";